exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material-stats{display:flex;flex-wrap:wrap;position:relative}.v-card--material-stats>div:first-child{justify-content:space-between}.v-card--material-stats .v-card{border-radius:4px;flex:0 1 auto}.v-card--material-stats .v-card__text{display:inline-block;flex:1 0 calc(100% - 120px);position:absolute;top:0;right:0;width:100%}.v-card--material-stats .v-card__actions{flex:1 0 100%}", ""]);

// exports
